import type { AppDependencies } from '../types.js';

export const ecomRequiredApps: AppDependencies = {
  appId: '1380b703-ce81-ff05-f115-39571d94dfcd',
  requiredApps: [
    {
      appName: 'Wix Stores',
      appId: '215238eb-22a5-4c36-9e7b-e7c08025e04e',
    },
    {
      appName: 'Wix Bookings',
      appId: '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
    },
    {
      appName: 'Wix Restaurants Orders',
      appId: '9a5d83fd-8570-482e-81ab-cfa88942ee60',
    },
    {
      appName: 'Wix Table Reservations',
      appId: 'f9c07de2-5341-40c6-b096-8eb39de391fb',
    },
  ],
};
